<script>
    import Modal from '../Modal.svelte';
    import BasicFormLayout from '../Form/BasicFormLayout.svelte';
    import yup from 'yup';
    import {sgettext} from '../../i18n.js';
    import {post} from '../../utils.js';
    import {IMPROVEMENT_API} from '../../apiUrls.js';
    import {onMount} from 'svelte';

    export let id;
    export let title;
    export let issueId;

    let isValid = true;

    const schema = yup.object().shape({
        comments: yup.string()
                .max(1024)
                .required(sgettext('$$REQUIRED_FIELD$$')),
    });

    let formModel = defaultFormModel();

    let fields = initialFields();

    function defaultFormModel() {
        return {
            comments: ''
        };
    }

    function initialFields() {
        return {
            comments: {
                label: sgettext('$$COMMENTS_1$$'),
                isValid: true,
                errors: null,
                type: 'text',
                multiline: true
            }
        }
    }

    async function onSave() {
        const resp = await post(`${IMPROVEMENT_API}${issueId}/reply_reporter/`, formModel);

        if (resp.ok) {
            const json = await resp.json();
            window.location.reload();
        }
    }

    onMount(() => {
        jQuery(`#${id}`).on('show.bs.modal', function () {
            jQuery('#comments').trigger('focus');
        });

        jQuery(`#${id}`).on('hidden.bs.modal', function () {
            formModel = defaultFormModel();
        });
    });
</script>

<style>

</style>

<Modal
        {id}
        {title}
        {onSave}
        {isValid}
        backdrop={'static'}>
    <div slot="body">
        <BasicFormLayout
                {id}
                {schema}
                {fields}
                {formModel}
        />
    </div>
</Modal>